import { render, staticRenderFns } from "./VoucherInput.vue?vue&type=template&id=b6679a64&scoped=true"
import script from "./VoucherInput.vue?vue&type=script&lang=js"
export * from "./VoucherInput.vue?vue&type=script&lang=js"
import style0 from "./VoucherInput.vue?vue&type=style&index=0&id=b6679a64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6679a64",
  null
  
)

export default component.exports